<template>
  <ActionIcon
    v-if="false && hasEstateAccount"
    icon="magic-wand"
    tooltip-position="is-top"
    :tooltip="tooltip"
    :action-fn="onClick"
    :loading="isRestoring"
  />
</template>

<script>
import { Estate } from '@/modules/estate/models/Estate';
import ActionIcon from '@/modules/core/app/components/ActionIcon.vue';
import { HasAuthUserMixin } from '@/modules/core/app/mixins/HasAuthUserMixin';
import { SpotlightEvent } from '@/modules/spotlight/events/SpotlightEvent';
import { NotificationService } from '@/modules/core/ui/services/NotificationService';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'SpotlightEstateRestoreAction',
  mixins: [HasAuthUserMixin],
  components: {
    ActionIcon
  },
  props: {
    estate: Estate
  },
  data() {
    return {
      isRestoring: false
    };
  },
  computed: {
    tooltip() {
      return this.$t('Restore estate');
    },
    hasEstateAccount() {
      return this.estate.estateAccounts.some((ea) => ea.userId === this.authUser.id);
    }
  },
  methods: {
    async restore() {
      this.isRestoring = true;
      this.isRestoring = false;
    },
    async onClick() {
      await this.restore();
      EventBus.signal(SpotlightEvent.CLOSE_SEARCH);
      NotificationService.show(this.$t('Estate has been restored. You can search it again.'));
    }
  }
};
</script>
